export default {
  admin: 'Administrador',
  password: {
    enterNewPassword: 'Ingrese una nueva contraseña',
    reenterNewPassword: 'Vuelva a ingresar la nueva contraseña',
    updatePassword: 'Actualizar contraseña',
    setPassword: 'Establecer contraseña',
    min8CharacterMessage: 'La contraseña debe tener al menos 8 caracteres',
    passwordSentMessage: 'La contraseña ha sido enviada a {userName} por correo electrónico.',
    generateNewPassword: 'Generar nueva contraseña',
    assignPasswordMessage:
      'Asigne una contraseña para el usuario. El usuario deberá cambiar esta contraseña en su próximo inicio de sesión.',
    generateSecurePassword: 'Generar contraseña segura',
    newPassword: 'Nueva contraseña',
    confirmNewPassword: 'Confirmar nueva contraseña',
    passwordHistory: 'Historial de contraseñas',
    passwordUpdatedLog: 'Contraseña actualizada por {userName} el {date}.',
    forgotPasswordLog: 'Solicitud de contraseña olvidada enviada por {userName} el {date}.',
  },
};
